import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Volume2, Square, Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { playText, stopAudio, onPlaybackChange, voiceErrorMessage } from "../lib/voice";

export const useIsPremium = () => {
  const { user } = useAuth();
  return user?.role === "admin" || user?.tier === "premium";
};

export function ListenButton({ text, testid = "listen-btn", label = "Listen", className = "" }) {
  const premium = useIsPremium();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => onPlaybackChange((k) => {
    setPlaying(k === text);
    if (k === text) setLoading(false);
  }), [text]);

  const click = async (e) => {
    e.stopPropagation();
    if (!premium) {
      toast("Listening is a Premium feature", { action: { label: "Upgrade", onClick: () => navigate("/pricing") } });
      return;
    }
    if (playing) { stopAudio(); return; }
    setLoading(true);
    try {
      await playText(text);
    } catch (err) {
      toast.error(await voiceErrorMessage(err));
    } finally { setLoading(false); }
  };

  const Icon = !premium ? Lock : loading ? Loader2 : playing ? Square : Volume2;
  return (
    <button type="button" onClick={click} data-testid={testid} title={premium ? label : "Premium: listen aloud"}
      className={`inline-flex items-center gap-1.5 text-xs transition-colors ${playing ? "text-primary" : "text-foreground/70 hover:text-primary"} ${className}`}>
      <Icon size={13} className={loading ? "animate-spin" : ""} />
      {playing ? "Stop" : label}
    </button>
  );
}
